import { LeaveComponent } from "../../components";

export default function LeaveRegistrationPage() {
  return <LeaveComponent.LeaveRegistrationList />;
}
